<template>
    <join-page />
</template>
<script>
    import { Component, Vue } from "vue-property-decorator";
    import JoinPage from '@/components/join/index.vue';

	@Component({
        components: {
            JoinPage
        }
    })
	export default class Join extends Vue {
        
    }
</script>